<div
  class="score-box score-box-focus"
  [style.border-color]="scoreColor"
  [class.score-focused]="mouseOverAlert || isFocused"
  (mouseover)="mouseOverAlert = true"
  (mouseout)="mouseOverAlert = false"
  [ngClass]="flagType"
  (click)="onScoreClick()"
>
  <ng-container *ngIf="!isLoading; else loadingEventsPlaceholder">
    <div class="score-container-cont">
      <div [ngSwitch]="scoreType">
        <!-- FLAG -->
        <ng-container *ngSwitchCase="'flag'">
          <div class="score-name-cont">
            <span class="score-icon">
              <mat-icon>flag</mat-icon>
            </span>
            <span>{{ scoreName }}</span>
          </div>
        </ng-container>

        <!-- SENTIMENT SCORE -->
        <ng-container *ngSwitchCase="'sentiment'">
          <div class="score-name-cont">
            <span class="score-icon" [style.color]="scoreColor">
              <svg-icon src="assets/icon/o_sentiment.svg"></svg-icon>
            </span>
            <span>{{ scoreName }}</span>
            <span class="score-value" [style.color]="scoreColor">{{
              scoreData?.sentiment | percent
            }}</span>
            <span class="score-trend" [style.color]="scoreColor">
              ({{ scoreData?.sentiment_delta * 100 | round | trend
              }}{{ scoreData?.sentiment_delta * 100 | round | negative }})
            </span>
          </div>
        </ng-container>

        <!-- BB SCORE -->
        <ng-container *ngSwitchCase="'bb'">
          <div class="score-name-cont">
            <span class="score-icon bb-icon" [style.color]="scoreColor">
              <img
                *ngIf="scoreData?.trend_type === 'bear'"
                src="assets/icon/bear.svg"
              />
              <img
                *ngIf="scoreData?.trend_type === 'bull'"
                src="assets/icon/bull.svg"
              />
            </span>
            <span>{{ scoreName }}</span>
            <span class="score-value" [style.color]="scoreColor">{{
              scoreData?.trend_value
            }}</span>
          </div>
        </ng-container>

        <!-- DEFAULT SCORE -->
        <ng-container *ngSwitchDefault>
          <div class="score-name-cont">
            <span class="score-icon" [style.color]="scoreColor" *ngIf="iconSrc">
              <svg-icon [src]="iconSrc"></svg-icon>
            </span>
            <span>{{ scoreName }}</span>
            <span class="score-value" [style.color]="scoreColor">{{
              scoreValue
            }}</span>
          </div>
        </ng-container>
      </div>

      <div class="score-info-cont">
        <span *ngIf="scoreEventsCount !== null">
          {{ scoreEventsCount | thousandSuff }} events in previous
          {{ scoreEventsTimeframe }} days
        </span>
        <span *ngIf="scoreEventsCount === null && scoreEventsTimeframe">
          previous {{ scoreEventsTimeframe }} days
        </span>
      </div>
    </div>
  </ng-container>

  <ng-template #loadingEventsPlaceholder>
    <mat-progress-spinner
      diameter="24"
      mode="indeterminate"
    ></mat-progress-spinner>
  </ng-template>
</div>
